import React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { compose } from 'redux';
import { hasAuthUserAdminPermissionSelector, isSuperAdminSelector } from '@redux/person/personSelector';
import { ReduxState } from '@redux/types';
import { Text } from 'components/Typography';
import NavTopBar from 'navigation/NavTopBar/NavTopBar';
import { RouteNames } from 'utils/navigationUtils';
import style from './ManageOrganizationLayout.scss';

type PropsFromRedux = ConnectedProps<typeof connectRedux>;

const ManageOrganizationLayout: React.FC<PropsFromRedux> = ({ hasAuthUserAdminPermission, isSuperAdmin }) => {
  const location = useLocation();
  const navigate = useNavigate();

  // Block access if user is not an Org Admin or Super Admin
  if (!hasAuthUserAdminPermission && !isSuperAdmin) {
    return null;
  }

  const isGeneralActive = location.pathname === RouteNames.MANAGE_ORGANIZATION || location.pathname === RouteNames.MANAGE_ORGANIZATION_GENERAL;
  const isMembersActive = location.pathname === RouteNames.MANAGE_ORGANIZATION_MEMBERS;

  return (
    <div className={style.container}>
      <NavTopBar />
      <div className={style.pageContainer}>
        <div className={style.headerContainer}>
          <Text className={style.header}>
            Manage Organization
          </Text>
        </div>
        <div className={style.mainContent}>
          <div className={style.leftSection}>
            <button
              className={`${style.sectionButton} ${isGeneralActive ? style.active : ''}`}
              onClick={() => navigate(RouteNames.MANAGE_ORGANIZATION_GENERAL)}
            >
              General
            </button>
            <button
              className={`${style.sectionButton} ${isMembersActive ? style.active : ''}`}
              onClick={() => navigate(RouteNames.MANAGE_ORGANIZATION_MEMBERS)}
            >
              Members
            </button>
          </div>
          <div className={style.rightSection}>
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
};

const connectRedux = connect((state: ReduxState) => ({
  hasAuthUserAdminPermission: hasAuthUserAdminPermissionSelector(state),
  isSuperAdmin: isSuperAdminSelector(state)
}));

export default compose(connectRedux)(ManageOrganizationLayout) as React.ComponentType;
